exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container{max-width:1200px;margin:0 auto}.alert-info{background-color:#d1ecf1;border-color:#bee5eb;color:#0c5460}.callout-danger{display:none}", ""]);

// exports
